/**
 * Vuex module for chat.
 */
import actions from './actions'
import mutations from './mutations'
import SmsSortByFilter from './sms_sort_by'
import SmsFilters from './sms_filters'
import DmSortByFilter from './dm_sort_by'
import DmFilters from './dm_filters'
import ChannelsSortByFilter from './channels_sort_by'
import ChannelsFilters from './channels_filters'
import GroupsSortByFilter from './groups_sort_by'
import GroupsFilters from './groups_filters'
import SmsToEmails from './sms_to_email'

const state = {
  unread: 0,
  sending: false,
  directConversationSelected: -1,
  roomSelected: null,
  smsSelected: -1,
  channelSelected: -1,
  channels: [],
  channelsLoading: false,
  channelMembers: [],
  groupMembers: [],
  groupSelected: -1,
  groups: [],
  groupsLoading: false,
  smsDids: [],
  channelToggle: null,
  groupToggle: null,
  directConversations: [],
  directConversationsLoading: false,
  smsConversations: [],
  smsConversationsLoading: false,
  authenticatedRocketChatUser: null,
  availableUsersDrawer: false,
  confirmChannelActionDialog: false,
  openRenameChannelDialog: false,
  openMembersChannelDialog: false,
  confirmGroupActionDialog: false,
  openRenameGroupDialog: false,
  openMembersGroupDialog: false,
  openNewConversationDialog: false,
  openDeleteDirectChatDialog: false,
  contextMenuRoomId: null,
  contextMenuChannelAction: null,
  contextMenuChannel: null,
  contextMenuMember: null,
  contextMenuGroupAction: null,
  contextMenuGroup: null,
  contextMenuGroupMember: null,
  presences: [],
  presenceTypes: [],
  users: [],
  smsFilters: [],
  realTimeAPI: null,
  paginationDm: {
    offset: 0,
    limit: 50,
    total: 0
  },
  paginationSms: {
    offset: 0,
    limit: 50,
    total: 0
  },
  paginationChannels: {
    offset: 0,
    limit: 50,
    total: 0
  },
  paginationGroups: {
    offset: 0,
    limit: 50,
    total: 0
  },
  dmLoaded: false,
  smsLoaded: false,
  channelsLoaded: false,
  groupsLoaded: false,
  smsPageSize: 50,
  dmPageSize: 50,
  channelsPageSize: 50,
  groupsPageSize: 50
}

const getters = {
  authenticatedRocketChatUser: state => state.authenticatedRocketChatUser,
  channels: state => state.channels,
  groups: state => state.groups,
  channelMembers: state => state.channelMembers,
  groupMembers: state => state.groupMembers,
  smsDids: state => state.smsDids,
  channelToggle: state => state.channelToggle,
  groupToggle: state => state.groupToggle,
  sending: state => state.sending,
  memberToKick: state => state.memberToKick,
  smsConversations: state => state.smsConversations,
  directConversations: state => state.directConversations,
  roomSelected: state => state.roomSelected,
  channelSelected: state => state.channelSelected,
  groupSelected: state => state.groupSelected,
  directConversationSelected: state => state.directConversationSelected,
  smsFilters: state => state.smsFilters,
  smsSelected: state => state.smsSelected,
  availableUsersDrawer: state => state.availableUsersDrawer,
  confirmChannelActionDialog: state => state.confirmChannelActionDialog,
  openRenameChannelDialog: state => state.openRenameChannelDialog,
  openMembersChannelDialog: state => state.openMembersChannelDialog,
  confirmGroupActionDialog: state => state.confirmGroupActionDialog,
  openRenameGroupDialog: state => state.openRenameGroupDialog,
  openMembersGroupDialog: state => state.openMembersGroupDialog,
  openNewConversationDialog: state => state.openNewConversationDialog,
  openDeleteDirectChatDialog: state => state.openDeleteDirectChatDialog,
  users: state => state.users,
  contextMenuRoomId: state => state.contextMenuRoomId,
  contextMenuChannelAction: state => state.contextMenuChannelAction,
  contextMenuChannel: state => state.contextMenuChannel,
  contextMenuMember: state => state.contextMenuMember,
  contextMenuGroupAction: state => state.contextMenuGroupAction,
  contextMenuGroup: state => state.contextMenuGroup,
  contextMenuGroupMember: state => state.contextMenuGroupMember,
  presences: state => state.presences,
  presenceTypes: state => state.presenceTypes,
  unread: state => state.unread,
  realTimeAPI: state => state.realTimeAPI,
  paginationDm: state => state.paginationDm,
  paginationSms: state => state.paginationSms,
  paginationChannels: state => state.paginationChannels,
  paginationGroups: state => state.paginationGroups,
  dmLoaded: state => (state.paginationDm?.total - (state.paginationDm?.limit + state.paginationDm?.offset)) <= 0,
  smsLoaded: state => (state.paginationSms?.total - (state.paginationSms?.limit + state.paginationSms?.offset)) <= 0,
  channelsLoaded: state => (state.paginationChannels?.total - (state.paginationChannels?.limit + state.paginationChannels?.offset)) <= 0,
  groupsLoaded: state => (state.paginationGroups?.total - (state.paginationGroups?.limit + state.paginationGroups?.offset)) <= 0,
  smsPageSize: state => state.smsPageSize,
  dmPageSize: state => state.dmPageSize,
  channelsPageSize: state => state.channelsPageSize,
  groupsPageSize: state => state.groupsPageSize,
  smsConversationsLoading: state => state.smsConversationsLoading,
  directConversationsLoading: state => state.directConversationsLoading,
  channelsLoading: state => state.channelsLoading,
  groupsLoading: state => state.groupsLoading
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    SmsSortByFilter,
    SmsFilters,
    DmSortByFilter,
    DmFilters,
    ChannelsSortByFilter,
    ChannelsFilters,
    GroupsSortByFilter,
    GroupsFilters,
    SmsToEmails
  }
}
